import {
  GET_IMAGES_START,
  GET_IMAGES_SUCCESS,
  GET_IMAGES_FAIL,
  DELETE_IMAGE_START,
  DELETE_IMAGE_SUCCESS,
  DELETE_IMAGE_FAIL,
  POST_IMAGE_START,
  POST_IMAGE_SUCCESS,
  POST_IMAGE_FAIL,
  SELECT_IMAGE_ID,
} from 'actions/images';

import { ProcessStatus } from '@xmatters/common/constants/commonStatus';

export const getInitialState = () => ({
  items: [],
  selectedImageId: undefined,
  fetchStatus: ProcessStatus.NOT_STARTED,
  uploadStatus: ProcessStatus.NOT_STARTED,
  deleteStatus: ProcessStatus.NOT_STARTED,
});

export default function imagesReducer(state = getInitialState(), action) {
  switch (action.type) {
    case SELECT_IMAGE_ID: {
      return {
        ...state,
        selectedImageId: action.payload,
      };
    }
    case GET_IMAGES_START: {
      return {
        ...state,
        fetchStatus: ProcessStatus.IN_PROGRESS,
      };
    }
    case GET_IMAGES_SUCCESS: {
      return {
        ...state,
        fetchStatus: ProcessStatus.SUCCESS,
        items: action.payload.data,
      };
    }
    case GET_IMAGES_FAIL: {
      return {
        ...state,
        fetchStatus: ProcessStatus.ERROR,
      };
    }
    case POST_IMAGE_START: {
      return {
        ...state,
        uploadStatus: ProcessStatus.IN_PROGRESS,
      };
    }
    case POST_IMAGE_SUCCESS: {
      const image = action.payload;
      const items = [image, ...state.items];

      return {
        ...state,
        items,
        uploadStatus: ProcessStatus.SUCCESS,
        selectedImageId: image.id,
      };
    }
    case POST_IMAGE_FAIL: {
      return {
        ...state,
        uploadStatus: ProcessStatus.ERROR,
      };
    }
    case DELETE_IMAGE_START: {
      return {
        ...state,
        deleteStatus: ProcessStatus.IN_PROGRESS,
      };
    }
    case DELETE_IMAGE_SUCCESS: {
      const deletedImage = action.payload;
      const items = state.items.filter(image => image.id !== deletedImage.id);

      return {
        ...state,
        deleteStatus: ProcessStatus.SUCCESS,
        items,
      };
    }
    case DELETE_IMAGE_FAIL: {
      return {
        ...state,
        deleteStatus: ProcessStatus.ERROR,
      };
    }
    default: {
      return state;
    }
  }
}
